import React, { useState } from 'react';

const PrivacyPage: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="website-container">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <a href="/" className="logo-link">
              <img src="/assets/LogoBrown.png" alt="SobCof Logo" className="logo-img" />
            </a>
          </div>
          <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <a href="/" className="nav-link">Ana Sayfa</a>
            <a href="/#features" className="nav-link">Özellikler</a>
            <a href="/#how-it-works" className="nav-link">Nasıl Çalışır</a>
            <a href="/#download" className="nav-link">İndir</a>
            <a href="/contact" className="nav-link">İletişim</a>
            <a href="/cafe-partnership" className="nav-link">Kafe Partnerliği</a>
          </div>
          <div className="nav-toggle" onClick={toggleMobileMenu}>
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </div>
        </div>
      </nav>

      {/* Legal Content */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-header">
            <h1>Gizlilik Politikası</h1>
          </div>

          <div className="legal-body">
            <div className="section">
              <h2>1. Giriş</h2>
              <p>
                SobCof ("biz", "bizim" veya "SobCof") olarak, kullanıcılarımızın gizliliğini korumaya büyük önem veriyoruz. 
                Bu Gizlilik Politikası, kişisel bilgilerinizi nasıl topladığımızı, kullandığımızı, paylaştığımızı ve 
                koruduğumuzu açıklamaktadır.
              </p>
            </div>

            <div className="section">
              <h2>2. Topladığımız Bilgiler</h2>
              <h3>2.1 Doğrudan Sağladığınız Bilgiler</h3>
              <ul>
                <li>Ad, soyad ve kullanıcı adı</li>
                <li>E-posta adresi ve telefon numarası</li>
                <li>Doğum tarihi ve yaş bilgisi</li>
                <li>Cinsiyet ve cinsiyet tercihi</li>
                <li>Profil fotoğrafları (en fazla 6 adet)</li>
                <li>Biyografi ve ilgi alanları</li>
                <li>Kahve tercihleri ve favori kafe türleri</li>
                <li>Mesaj içerikleri ve sohbet geçmişi</li>
              </ul>

              <h3>2.2 Otomatik Toplanan Bilgiler</h3>
              <ul>
                <li>Konum bilgileri (kafe tespiti için)</li>
                <li>Cihaz bilgileri (işletim sistemi, cihaz modeli)</li>
                <li>Uygulama kullanım verileri</li>
                <li>IP adresi ve ağ bilgileri</li>
                <li>Çevrimiçi/çevrimdışı durumu</li>
                <li>Son aktiflik zamanı</li>
              </ul>
            </div>

            <div className="section">
              <h2>3. Bilgileri Nasıl Kullanıyoruz</h2>
              <p>Topladığımız bilgileri aşağıdaki amaçlarla kullanırız:</p>
              <ul>
                <li>Hesap oluşturma ve kullanıcı kimlik doğrulama</li>
                <li>Uyumlu eşleşmeler önerme ve algoritma geliştirme</li>
                <li>Kafe bazlı lokasyon hizmetleri sağlama</li>
                <li>Kullanıcılar arası iletişimi sağlama</li>
                <li>Güvenlik ve dolandırıcılık önleme</li>
                <li>Uygulama performansını iyileştirme</li>
                <li>Müşteri desteği sağlama</li>
                <li>Yasal yükümlülükleri yerine getirme</li>
              </ul>
            </div>

            <div className="section">
              <h2>4. Bilgi Paylaşımı</h2>
              <p>Kişisel bilgilerinizi aşağıdaki durumlarda paylaşabiliriz:</p>
              
              <h3>4.1 Diğer Kullanıcılarla</h3>
              <ul>
                <li>Profil bilgileri (eşleşme sonrası)</li>
                <li>Fotoğraflar ve biyografi</li>
                <li>Kahve tercihleri ve ilgi alanları</li>
                <li>Konum bilgisi (sadece kafe seviyesinde)</li>
              </ul>

              <h3>4.2 Üçüncü Taraf Hizmet Sağlayıcılar</h3>
              <ul>
                <li>Bulut depolama hizmetleri (AWS, Google Cloud)</li>
                <li>Analitik hizmetleri (Firebase Analytics)</li>
                <li>Ödeme işlemcileri (Premium özellikler için)</li>
                <li>Push notification hizmetleri</li>
              </ul>

              <h3>4.3 Yasal Gereklilikler</h3>
              <ul>
                <li>Mahkeme kararları ve yasal talepler</li>
                <li>Güvenlik ve dolandırıcılık soruşturmaları</li>
                <li>Acil durum müdahaleleri</li>
              </ul>
            </div>

            <div className="section">
              <h2>5. Veri Güvenliği</h2>
              <p>Kişisel bilgilerinizi korumak için aşağıdaki güvenlik önlemlerini alıyoruz:</p>
              <ul>
                <li>End-to-end şifreleme (mesajlar için)</li>
                <li>SSL/TLS şifreleme (veri aktarımı)</li>
                <li>Düzenli güvenlik denetimleri</li>
                <li>Erişim kontrolü ve yetkilendirme</li>
                <li>Veri yedekleme ve kurtarma sistemleri</li>
                <li>Güvenlik açığı izleme</li>
              </ul>
            </div>

            <div className="section">
              <h2>6. Haklarınız</h2>
              <p>KVKK ve GDPR kapsamında aşağıdaki haklara sahipsiniz:</p>
              <ul>
                <li><strong>Erişim Hakkı:</strong> Kişisel verilerinize erişim talep edebilirsiniz</li>
                <li><strong>Düzeltme Hakkı:</strong> Yanlış bilgilerin düzeltilmesini isteyebilirsiniz</li>
                <li><strong>Silme Hakkı:</strong> Hesabınızı ve verilerinizi silebilirsiniz</li>
                <li><strong>Taşınabilirlik Hakkı:</strong> Verilerinizi başka platforma aktarabilirsiniz</li>
                <li><strong>İtiraz Hakkı:</strong> Veri işlemeye itiraz edebilirsiniz</li>
                <li><strong>Sınırlama Hakkı:</strong> Veri işlemenin sınırlanmasını isteyebilirsiniz</li>
              </ul>
            </div>

            <div className="section">
              <h2>7. Çerezler ve Takip Teknolojileri</h2>
              <p>Uygulamamızda aşağıdaki teknolojileri kullanıyoruz:</p>
              <ul>
                <li><strong>Gerekli Çerezler:</strong> Temel uygulama işlevselliği</li>
                <li><strong>Analitik Çerezler:</strong> Kullanım istatistikleri</li>
                <li><strong>Performans Çerezler:</strong> Uygulama optimizasyonu</li>
                <li><strong>Reklam Çerezleri:</strong> Kişiselleştirilmiş reklamlar</li>
              </ul>
              <p>Çerez tercihlerinizi uygulama ayarlarından yönetebilirsiniz.</p>
            </div>

            <div className="section">
              <h2>8. Veri Saklama</h2>
              <p>Kişisel verilerinizi aşağıdaki sürelerle saklarız:</p>
              <ul>
                <li><strong>Aktif Hesaplar:</strong> Hesap silinene kadar</li>
                <li><strong>Silinen Hesaplar:</strong> 30 gün (kurtarma için)</li>
                <li><strong>Mesaj Geçmişi:</strong> 1 yıl</li>
                <li><strong>Analitik Veriler:</strong> 2 yıl</li>
                <li><strong>Yasal Kayıtlar:</strong> Yasal gereklilik süresi</li>
              </ul>
            </div>

            <div className="section">
              <h2>9. Çocukların Gizliliği</h2>
              <p>
                SobCof, 18 yaşından küçük kullanıcılara yönelik değildir. 18 yaşından küçük bireylerden 
                bilerek kişisel bilgi toplamayız. Eğer 18 yaşından küçük bir kullanıcının bilgilerini 
                topladığımızı fark edersek, bu bilgileri derhal sileriz.
              </p>
            </div>

            <div className="section">
              <h2>10. Uluslararası Veri Aktarımı</h2>
              <p>
                Verileriniz, hizmet kalitesini artırmak için güvenli sunucularda saklanabilir. 
                Tüm uluslararası veri aktarımları, uygun güvenlik önlemleri ve yasal gereklilikler 
                çerçevesinde gerçekleştirilir.
              </p>
            </div>

            <div className="section">
              <h2>11. Politika Değişiklikleri</h2>
              <p>
                Bu Gizlilik Politikası'nı zaman zaman güncelleyebiliriz. Önemli değişiklikler 
                durumunda size bildirimde bulunacağız. Güncellenmiş politika, yayınlandığı 
                tarihten itibaren geçerli olacaktır.
              </p>
            </div>

            <div className="section">
              <h2>12. İletişim</h2>
              <p>
                Gizlilik politikamız hakkında sorularınız varsa veya haklarınızı kullanmak 
                istiyorsanız bizimle iletişime geçebilirsiniz:
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <a href="/" className="logo-link">
                  <img src="/assets/LogoWhite.png" alt="SobCof Logo" />
                </a>
              </div>
              <p className="footer-description">
                Kahve severler için sosyal keşif platformu. En iyi kafeleri keşfet, yeni insanlarla tanış.
              </p>
              <div className="social-links">
                <a href="https://instagram.com/sobcof" title="Instagram" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                <a href="https://tiktok.com/@sobcof" title="TikTok" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
                <a href="https://twitter.com/sobcof" title="Twitter" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                <a href="https://youtube.com/@sobcof" title="YouTube" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
              </div>
            </div>

            <div className="footer-section">
              <h4>Ürün</h4>
              <ul>
                <li><a href="/#features">Özellikler</a></li>
                <li><a href="/#premium">Premium</a></li>
                <li><a href="/#download">İndir</a></li>
                <li><a href="/#security">Güvenlik</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Destek</h4>
              <ul>
                <li><a href="/help">Yardım Merkezi</a></li>
                <li><a href="/contact">İletişim</a></li>
                <li><a href="/feedback">Geri Bildirim</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Yasal</h4>
              <ul>
                <li><a href="/privacy">Gizlilik Politikası</a></li>
                <li><a href="/terms">Kullanım Koşulları</a></li>
                <li><a href="/cookies">Çerez Politikası</a></li>
                <li><a href="/gdpr">KVKK</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2026 SobCof. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
